export const COMPLETE_VEHICLE = 'Vehicle';
export const THIRD_PARTY_VEHICLE = 'VehicleRC';

// NOTE: this will change
export const THIRD_PARTY_PACK = 'VehicleRC_PACK';
